var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 128,
    viewBox: "0 0 152 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_959_4615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4482 116.507H107.284V71.0906C107.284 68.7734 105.424 66.9197 103.1 66.9197H7.71669C5.39253 66.9197 3.5332 68.7734 3.5332 71.0906V116.507H11.8072",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.199 95.9305H107.377V79.3396H119.834C126.621 79.3396 132.199 95.9305 132.199 95.9305Z",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.473 116.507H148.747V104.087C148.747 99.5454 145.028 95.8379 140.473 95.8379H107.377V116.507H123.925",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.199 124.756C136.768 124.756 140.473 121.063 140.473 116.507C140.473 111.951 136.768 108.258 132.199 108.258C127.629 108.258 123.925 111.951 123.925 116.507C123.925 121.063 127.629 124.756 132.199 124.756Z",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1744 124.756C24.744 124.756 28.4484 121.063 28.4484 116.507C28.4484 111.951 24.744 108.258 20.1744 108.258C15.6048 108.258 11.9004 111.951 11.9004 116.507C11.9004 121.063 15.6048 124.756 20.1744 124.756Z",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9434 3.61475V14.6444",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0606 55.1486H3.99764L3.25391 54.9632C3.25391 26.4158 26.4955 3.24414 55.1291 3.24414C83.7628 3.24414 107.004 26.4158 107.004 54.9632L106.632 55.1486H95.5695",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.031 27.4352L18.1289 19.5569",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5996 27.4352L92.5017 19.5569",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5715 55.1484C59.0384 55.1484 62.6595 51.5382 62.6595 47.0847C62.6595 42.6312 59.0384 39.021 54.5715 39.021C50.1046 39.021 46.4834 42.6312 46.4834 47.0847C46.4834 51.5382 50.1046 55.1484 54.5715 55.1484Z",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5713 39.1136V25.9521",
    stroke: "#0C1932",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_959_4615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGauge);
export default __webpack_public_path__ + "static/media/TruckGauge.8bd59a45442aa025298f9dd95974331c.svg";
export { ForwardRef as ReactComponent };